<template lang="pug">
  v-row
    v-col(cols=12)
      v-row
        v-col(cols=12 md=8)
          student-actions(
            ref="studentActions"
            @resetTags="reset"
          )

        v-col(cols=12 md=4)
          course-units-filters(
            ref="courseUnitFilters"
            @input="fetchActions"
          ).actions-filters
</template>

<script>
import StudentActions from '../../components/StudentActions.vue';
import CourseUnitsFilters from '../../components/CourseUnitsFilters.vue';

export default {
  components: {
    StudentActions,
    CourseUnitsFilters,
  },
  data() {
    return {
      loading: {
        actionsLoading: true,
      },
    };
  },
  methods: {
    reset() {
      this.$refs.courseUnitFilters.reset();
    },
    async fetchActions(tags) {
      this.$refs.studentActions.init(tags);
    },
  },
};
</script>
